import Icon from "assets/icons";
import Variant from "shared/enums/Variant";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import { useRegDetail } from "shared/context/regDetail";
import useInvoicePayerRegConfirmationService from "./service";
import { PurchaseOrderTable } from "shared/components/purchaseOrder";
import { PaymentSuccessTransactionSubSet, TransactionStatus } from "shared/enums/TransactionStatus";
import React from "react";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import RegistrationFooter from "apps/registration/components/registrationFooter";

function InvoicePayerRegConfirmation() {
  const copies = useCopies();
  const { helpdeskEmail } = useRegDetail();
  const service = useInvoicePayerRegConfirmationService();
  return (
    <React.Fragment>
      <div className="regConfirmWrapper regConfirmWrapperInvoicePayer">
        <section className="container">
          <div className="purchaseConfirm">
            <div className="purchaseConfirm_wrapper">
              <div className="purchaseConfirm_tagsWrapper">
                <div className="purchaseConfirm_status">
                  {PaymentSuccessTransactionSubSet.includes(
                    service.transactionDetails.purchaseOrder?.transaction?.status as TransactionStatus
                  ) && <p className="purchaseConfirm_status--paymentReceived">{copies.get("payment.received")}</p>}
                </div>
              </div>
              <div className="purchaseConfirm_icon">
                <Icon.CheckMarkOutlineSlim />
              </div>
              <div className="purchaseConfirm_msgWrapper">
                <div className="purchaseConfirm_msgHeading">
                  <h3 className="purchaseConfirm_msgHeading--title">{copies.get("thank.you")}</h3>
                </div>
                <div className="purchaseConfirm_msgDetails">
                  <p className="purchaseConfirm_msgDetails--text">
                    {copies.get("invoice.payment.done.for.participant")}
                  </p>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: copies.get("email.support.with.questions", {
                        0: `<strong class="purchaseConfirm_msgDetails--helpdesk">${helpdeskEmail}</strong>`
                      })
                    }}
                  />
                </div>
              </div>
              <div className="purchaseConfirm_cardWrapper">
                <div className="purchaseConfirm_cardBody">
                  <div className="purchaseConfirm_cardLeft">
                    <h2 className="purchaseConfirm_cardLeft--regName">{service.regDetails.name?.toUpperCase()}</h2>
                    <span className="purchaseConfirm_cardLeft--regDate">
                      <Icon.Date />
                      {DateTimeHelper.formatDate({
                        startDate: service.regDetails.startDate,
                        endDate: service.regDetails.endDate
                      })}
                    </span>
                  </div>
                  <div className="purchaseConfirm_cardRight">
                    <div className="purchaseConfirm_cardRight_top">
                      <label className="purchaseConfirm_cardRight_top--label">
                        {copies.get("invoice.payment.paid.for")}
                      </label>
                      <p className="purchaseConfirm_cardRight_top--value">
                        {service.transactionDetails.registrationParticipant.workEmail}
                      </p>
                    </div>
                    <div className="purchaseConfirm_cardRight_bottom">
                      <label className="purchaseConfirm_cardRight_bottom--label">
                        {copies.get("invoice.payment.paid.by")}
                      </label>
                      <p className="purchaseConfirm_cardRight_top--value">
                        {service.transactionDetails.invoicePayerEmail}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {service.transactionDetails.purchaseOrder?.amount.value > 0 && (
                <React.Fragment>
                  <PurchaseOrderTable
                    purchaseOrder={service.transactionDetails.purchaseOrder}
                    originatingFormName={
                      service.transactionDetails.originatingFormName ?? service.transactionDetails.programName
                    }
                  />
                  {service.transactionDetails.purchaseOrder?.transaction?.status ===
                    TransactionStatus.PRE_AUTHORIZED && (
                    <div className="purchaseConfirm_footerMsg">
                      <p className="purchaseConfirm_footerMsg--text">
                        <Icon.InfoCircleThick /> {copies.get("payment.will.be.processed")}
                      </p>
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
            <div className="printHide purchaseConfirm_btnWrapper">
              <Button
                className="purchaseConfirm_btnWrapper--print"
                variant={Variant.PRIMARY}
                icon={<Icon.Print />}
                label={copies.get("print.confirmation")}
                isOutline
                onClick={() => {
                  window.scrollTo(0, 0);
                  window.print();
                }}
              />
            </div>
          </div>
        </section>
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
}

export default InvoicePayerRegConfirmation;
